export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/ce82aae38e929df8fcdd7e760ce92d73.svg";